import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { SignupFormComponent, SignupSuccessPayload } from '../signup-form/signup-form.component';
import { svgIconList } from '@shared/svg-icon-list';
import { showAuthErrorSwal } from '@shared/utils/auth-swal.util';
import { buildCrossLoginUrl } from '@shared/utils/cross-login.util';
import { DomainService } from '@core/services/domain.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [CommonModule, TranslateModule, SignupFormComponent],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss',
})
export class SignupComponent implements OnInit {
  isQP23 = ['qp23'].includes(environment.projectCode.toLowerCase());
  svg: any = svgIconList;

  private readonly isBrowser: boolean;

  constructor(
    private domainService: DomainService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private translateService: TranslateService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {}

  onSignupSuccess(payload: SignupSuccessPayload): void {
    if (!this.isBrowser) return;
    const { access_token, plaintext_token } = (payload.auth ?? ({} as any));
    const crossLoginUrl = buildCrossLoginUrl(this.domainService.getOldDomainUrl(), access_token, plaintext_token);
    if (crossLoginUrl) {
      window.location.href = crossLoginUrl;
    } else {
      this.router.navigate(['/home']);
    }
  }

  onSignupError(err: HttpErrorResponse): void {
    if (!this.isBrowser) return;
    showAuthErrorSwal(err, this.translateService);
  }

  onLogin(): void {
    this.router.navigate(['/login']);
  }
}
